webpackJsonp([230013016654144],{

/***/ 52:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var MAIL_TO = exports.MAIL_TO = "madet.adrien@gmail.com, vs.violainesimon@gmail.com";

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _constants = __webpack_require__(52);
	
	var _PageHeader = __webpack_require__(34);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _PostPreview = __webpack_require__(51);
	
	var _PostPreview2 = _interopRequireDefault(_PostPreview);
	
	__webpack_require__(520);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavLink = function NavLink(props) {
	  if (!props.isTrackable) {
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: props.url },
	      props.text
	    );
	  } else {
	    return _react2.default.createElement(
	      'span',
	      null,
	      props.text
	    );
	  }
	};
	
	var Posts = function Posts(_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext,
	      defaultPreview = _ref.defaultPreview;
	  var group = pathContext.group,
	      index = pathContext.index,
	      pageCount = pathContext.pageCount,
	      additionalContext = pathContext.additionalContext;
	  var postsCount = additionalContext.postsCount;
	
	
	  var previousUrl = index - 1 == 1 ? "" : (index - 1).toString();
	  var nextUrl = (index + 1).toString();
	
	  var first = index == 1 ? true : false;
	  var last = index == pageCount ? true : false;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'main postsPage-mainContent' },
	    _react2.default.createElement(_PageHeader2.default, {
	      title: 'Tous les articles',
	      subtitle: postsCount + ' articles'
	    }),
	    group.map(function (_ref2) {
	      var node = _ref2.node;
	      var banner = node.frontmatter.banner;
	
	
	      var postBanner = banner ? banner.childImageSharp.sizes : defaultPreview.sizes;
	
	      return _react2.default.createElement(_PostPreview2.default, {
	        key: node.id,
	        data: node,
	        image: postBanner,
	        className: 'postPreview--fullWidth'
	      });
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'posts-paginate-links' },
	      !first && _react2.default.createElement(
	        'div',
	        { className: 'posts-paginate-links-previous' },
	        _react2.default.createElement(NavLink, { isTrackable: first, url: '/posts/' + previousUrl, text: '< Pr\xE9c\xE9dents' })
	      ),
	      !last && _react2.default.createElement(
	        'div',
	        { className: 'posts-paginate-links-next' },
	        _react2.default.createElement(NavLink, { isTrackable: last, url: '/posts/' + nextUrl, text: 'Suivants >' })
	      )
	    )
	  );
	};
	
	Posts.propTypes = {
	  data: _propTypes2.default.object
	};
	
	exports.default = Posts;
	module.exports = exports['default'];

/***/ }),

/***/ 520:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-posts-jsx-946adfdc0ba13ec59628.js